import React from 'react';

import img1 from '../../Images/Home.webp';
import img2 from '../../Images/About.webp';
import img3 from '../../Images/Skill.webp';
import img4 from '../../Images/Project.webp';
import img5 from '../../Images/Contact.webp';

export const SidebarData = [{
        title: 'Home',
        path: '/',
        icon: img1,
        cName: 'nav-text'
    },
    {
        title: 'About Us',
        path: '/about',
        icon: img2,
        cName: 'nav-text'
    },
    {
        title: 'Skills',
        path: '/skill',
        icon: img3,
        cName: 'nav-text'
    },
    {
        title: 'Projects',
        path: '/project',
        icon: img4,
        cName: 'nav-text'
    },
    {
        title: 'Contact Us',
        path: '/contact',
        icon: img5,
        cName: 'nav-text'
    }
];